import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import onRecipientsChanged from './onRecipientsChanged';
import removeRecipientFromRecipientWell from 'owa-recipient-common/lib/actions/removeRecipientFromRecipientWell';
import setCommonWellItemSelectedState from 'owa-readwrite-common-well/lib/actions/setCommonWellItemSelectedState';
import { action } from 'satcheljs/lib/legacy';

export default action('removeReadWriteRecipients')(function removeReadWriteRecipients(
    recipientWell: RecipientWellWithFindControlViewState,
    recipientsLocatorToRemove: (ReadWriteRecipientViewState | number)[],
    selectToRight?: boolean,
    willTriggerRecipientsChangedEvent: boolean = true
) {
    let hasRemovedAnyRecipient = false;
    for (let recipientLocatorToRemove of recipientsLocatorToRemove) {
        let indexToRemove = -1;
        if (typeof recipientLocatorToRemove === 'number') {
            indexToRemove = recipientLocatorToRemove;
        } else {
            indexToRemove = recipientWell.recipients.indexOf(recipientLocatorToRemove);
        }
        if (indexToRemove >= 0) {
            let recipientToRemove = recipientWell.recipients[indexToRemove];
            if (recipientToRemove.blockWellItemRemoval) {
                return;
            }

            removeRecipientFromRecipientWell(
                indexToRemove,
                recipientWell,
                selectToRight,
                onRemovedRecipientCallback
            );

            hasRemovedAnyRecipient = true;
        }
    }

    if (willTriggerRecipientsChangedEvent && hasRemovedAnyRecipient) {
        onRecipientsChanged(recipientWell);
    }
});

function onRemovedRecipientCallback(
    removedRecipient: ReadWriteRecipientViewState[],
    indexToRemove: number,
    recipientWell: RecipientWellWithFindControlViewState,
    selectToRight?: boolean
) {
    if (removedRecipient[0].isSelected && recipientWell.recipients.length > 0) {
        setCommonWellItemSelectedState(
            recipientWell.recipients[
                selectToRight
                    ? Math.min(indexToRemove, recipientWell.recipients.length - 1)
                    : Math.max(0, indexToRemove - 1)
            ],
            true
        );
    }
}
